import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { GOOGLE_REVIEW_URL } from "../lib/brand";
import { Heart, Loader2, Flame, Star } from "lucide-react";

const TipSuccessPage = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ status: "polling", amount: 0 });

  useEffect(() => {
    if (!sessionId) { setState({ status: "error", amount: 0 }); return; }
    let active = true;
    let attempts = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/tips/status/${sessionId}`);
        if (!active) return;
        if (r.data.payment_status === "paid") {
          setState({ status: "paid", amount: r.data.amount });
          return;
        }
        attempts += 1;
        if (attempts >= 30) { setState({ status: "timeout", amount: r.data.amount }); return; }
        setTimeout(poll, 2000);
      } catch { setState({ status: "error", amount: 0 }); }
    };
    poll();
    return () => { active = false; };
  }, [sessionId]);

  return (
    <div className="min-h-[80vh] flex items-center" data-testid="tip-success-page">
      <div className="max-w-xl mx-auto px-6 py-24 w-full">
        <div className="border border-[#262626] bg-[#0a0a0a] p-10 md:p-14 text-center">
          {state.status === "polling" && (
            <>
              <Loader2 size={48} className="text-[#D90429] animate-spin mx-auto" />
              <h1 className="mt-6 font-display text-3xl font-bold uppercase tracking-tight">Confirming…</h1>
            </>
          )}
          {state.status === "paid" && (
            <>
              <Heart size={56} className="text-[#D90429] mx-auto flame-pulse" />
              <h1 className="mt-6 font-display text-4xl font-black uppercase tracking-tighter">Thank You ❤️‍🔥</h1>
              <p className="mt-4 text-[#A3A3A3]">Your <span className="text-[#D90429] font-bold">${state.amount.toFixed(2)}</span> tip means everything to a small business. We truly appreciate you.</p>

              {/* Review CTA right after the tip thank-you */}
              <div className="mt-8 border-2 border-[#D90429] bg-[#D90429]/10 p-6 text-center" data-testid="review-cta">
                <div className="flex justify-center mb-2">
                  {[0,1,2,3,4].map(i => <Star key={i} size={18} className="text-[#D90429] fill-[#D90429]"/>)}
                </div>
                <div className="font-display uppercase tracking-[0.2em] text-[10px] text-[#D90429]">One more thing</div>
                <h2 className="mt-1 font-display text-xl font-black uppercase tracking-tight">Leave us a quick Google review?</h2>
                <p className="mt-2 text-xs text-[#D4D4D4]">30 seconds — huge for a small biz like us.</p>
                <a
                  href={GOOGLE_REVIEW_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="review-cta-btn"
                  className="mt-4 inline-flex items-center gap-2 bg-[#D90429] hover:bg-[#EF233C] text-white font-display font-bold tracking-wider uppercase px-6 py-3 text-xs transition-colors"
                >
                  <Star size={14} className="fill-white"/> Leave a Review
                </a>
              </div>

              <Link to="/" data-testid="tip-home-btn" className="mt-8 inline-flex items-center gap-2 bg-[#D90429] hover:bg-[#EF233C] text-white font-display font-bold tracking-wider uppercase px-8 py-4 transition-colors">
                <Flame size={16}/> Back home
              </Link>
            </>
          )}
          {state.status !== "polling" && state.status !== "paid" && (
            <>
              <h1 className="font-display text-3xl font-bold uppercase tracking-tight">Payment not confirmed</h1>
              <p className="mt-3 text-[#A3A3A3]">If you completed payment, give it a minute and refresh.</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TipSuccessPage;
